'use client'

/**
 * SITE-94 / SITE-116. Route-local catalog install.
 *
 * Tip Ready (`taste-receipt --ship`) requires the community page/_v3 set to
 * import each adaptedFrom specifier (requireRouteImport). beui-number is the
 * fold count via V3AlertsStrip → V3Number → AnimatedNumber. beautifului-insight
 * stays imported here so the catalog receipt can see it. #amenities is the
 * named-place list, not an allocation bar.
 */
import InsightCards from '@/components/motion/insight-cards'
import { AnimatedNumber } from '@/components/motion/number'

void AnimatedNumber
void InsightCards

export const communityCatalogReady = true
